// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"6ca29dfb","708":"66446194","875":"64f41752"}[chunkId] + ".chunk.css";
};